import { render, staticRenderFns } from "./DropdownMenu.vue?vue&type=template&id=67a01a45&scoped=true&lang=pug&"
import script from "./DropdownMenu.vue?vue&type=script&lang=ts&"
export * from "./DropdownMenu.vue?vue&type=script&lang=ts&"
import style0 from "./DropdownMenu.vue?vue&type=style&index=0&id=67a01a45&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a01a45",
  null
  
)

export default component.exports